import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fade } from '@core/animations/animations';
import { TitleInsuranceProvider } from '@models/title-insurance';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { AddTitleInsuranceComponent } from './components/add-title-insurance/add-title-insurance.component';
import { YES_NO_OPTIONS } from 'src/app/ui/utils/constants';
import { TestHooks } from './title-insurance.hooks';

@Component({
	selector: 'app-title-insurance',
	templateUrl: './title-insurance.component.html',
	styleUrls: ['./title-insurance.component.scss'],
	animations: [fade()],
	standalone: false,
})
export class TitleInsuranceComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	public yesNoOptions = YES_NO_OPTIONS;
	public provider = TitleInsuranceProvider;

	@ViewSelectSnapshot(SelectedMatter.getTitleInsuranceProvider)
	titleInsuranceProvider: TitleInsuranceProvider;

	constructor(private matDialog: MatDialog) {}

	addTitleInsurance() {
		this.matDialog.open(AddTitleInsuranceComponent);
	}
}
